import { render, staticRenderFns } from "./ChangePayCardSmall.vue?vue&type=template&id=6d60be4a&scoped=true"
import script from "./ChangePayCardSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePayCardSmall.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChangePayCardSmall.vue?vue&type=style&index=0&id=6d60be4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60be4a",
  null
  
)

export default component.exports